import React from 'react';
import initializeComponent from '../Shared/react-initialize';
import PropTypes from 'prop-types';
import ShippingFlagTooltip from './shipping_flag_tooltip';

const attributeToInfo = {
   is_battery: {
      notice: 'Shipping restrictions apply',
      text:
         'Batteries may only be shipped within the contiguous USA at this time and may only ship via standard shipping.',
      link: 'https://help.ifixit.com/article/195-battery-shipping-warnings',
   },
   is_dangerous: {
      notice: 'Shipping restrictions apply',
      text: 'New safety regulations for dangerous goods may cause shipping delays.',
      link:
         'https://help.ifixit.com/article/264-what-are-the-shipping-restrictions-for-orders-containing-dangerous-goods',
   },
   us_only: {
      notice: 'US shipping only',
      text:
         'Due to shipping regulations, iFixit may only ship this product within the United States of America.',
   },
   does_not_ship_to_mexico: {
      notice: 'Mexico shipping unavailable',
      text: 'Due to shipping regulations, iFixit may not ship this product to Mexico.',
   },
};

function ShippingFlagNotice({ attribute }) {
   const { notice, text, link } = attributeToInfo[attribute];

   return (
      <ShippingFlagTooltip notice={notice}>
         <div>
            <p>{_js(text)}</p>
            {link && (
               <p>
                  <a href={link} target="_blank">
                     {_js('Learn more')}
                  </a>
               </p>
            )}
         </div>
      </ShippingFlagTooltip>
   );
}

ShippingFlagNotice.propTypes = {
   attribute: PropTypes.oneOf(Object.keys(attributeToInfo)).isRequired,
};

initializeComponent('ShippingFlagNotice', ShippingFlagNotice);
